import { Select } from '@trufla-technology/trumarket-react-design-system';
import { CustomSelectProps } from '../CurrencySelect';

export const languages = [
  { label: 'English (UK)', value: 'en-GB' },
  { label: 'English (CA)', value: 'en-CA' },
  { label: 'English (US)', value: 'en-US' },
];

export const LocalizationSelect = ({
  onChange,
  value,
  disabled,
}: CustomSelectProps) => {
  return (
    <Select disabled={disabled} onChange={onChange} value={value}>
      {languages.map(({ value, label }) => (
        <option key={`currency-option-${value}`} value={value}>
          {label}
        </option>
      ))}
    </Select>
  );
};
